<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<!-- this below span is for ltr2 where we need header in no data scenariio -->
	<span *ngIf="!hasData" class="sem-header"></span>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
		*ngIf="hasData"
	>
		<div class="o-stack__cell portlet-subheader-wrapper">
			<h5 *ngIf="semCreativeCard">{{ semCreativeCard.ad_headline }}</h5>
			<h6 class="portlet-subheader" style="font-size: 1.1em;" *ngIf="totalCreatives > 0">
				{{ count }} of {{ totalCreatives }} SEM creatives in selected date range
			</h6>
			<h6 class="portlet-subheader1" style="font-size: 1.1em; display: none;" *ngIf="totalCreatives > 0">
				{{ count }} | {{ totalCreatives }}
			</h6>
			<h6 class="portlet-subheader" *ngIf="totalCreatives == 0" style="font-size: 1.1em;">No Data to Display</h6>
			<span *ngIf="hasData">
				<a
					href="javascript:void(0)"
					class="datatable_download_icon"
					(click)="downloadCSV()"
					target="_blank"
					*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
				>
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</span>
		</div>
	</div>
	<div class="c-portlet__content u-pt-small" style="width: 100%; position: relative;" *ngIf="hasData">
		<div class="o-stack__cell" style="position: absolute; width: 100%; height: 100%;" *ngIf="totalCreatives > 1">
			<div class="o-stack o-stack--center o-stack--nowrap" style="width: 100%; height: 100%; position: relative;">
				<div class="o-stack__cell u-relative" style="width: 100%; height: 100%;">
					<a
						class="u-opacity-50p"
						style="
							font-size: 5rem;
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							left: 0px;
							z-index: 9999;
						"
					>
						<span class="next" (click)="nextArrow()" class="carousel-arrow-style"
							><i style="font-size: 5rem;" class="fa fa-angle-left" aria-hidden="true"></i></span
					></a>
					<a
						class="u-opacity-50p"
						style="
							font-size: 5rem;
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							right: 0px;
							z-index: 9999;
						"
					>
						<span class="prev" (click)="prevArrow()" class="carousel-arrow-style"
							><i style="font-size: 5rem;" class="fa fa-angle-right" aria-hidden="true"></i
						></span>
					</a>
				</div>
			</div>
		</div>
		<div class="analytics-portlet-content sem-creative-card-container">
			<div *ngIf="semCreativeCard && hasData">
				<div class="display-carousel-table-container">
					<ul class="creative-stats">
						<li>
							<span class="stats">{{ semCreativeCard.impressions | number }}</span>
							<span class="stats-label">Impressions</span>
						</li>
						<li>
							<span class="stats">{{ semCreativeCard.clicks | number }}</span>
							<span class="stats-label">Clicks</span>
						</li>
						<li>
							<span class="stats">{{ semCreativeCard.clickthroughrate | number: '1.0-2' }}%</span>
							<span class="stats-label">CTR</span>
						</li>
						<li *ngIf="!isGoliveNotStarted">
							<span class="stats">{{ semCreativeCard.absTopImpressionShare | number: '1.0-2' }}%</span>
							<span class="stats-label">Abs.Top Imp.</span>
						</li>
						<li *ngIf="!isGoliveNotStarted">
							<span class="stats">{{ semCreativeCard.topImpressionShare | number: '1.0-2' }}%</span>
							<span class="stats-label">Top Imp.</span>
						</li>
						<li *ngIf="!isCutoffDate">
							<span class="stats" *ngIf="semCreativeCard.avg_position">{{
								semCreativeCard.avg_position ? (semCreativeCard.avg_position | number) : '--'
							}}</span>
							<span class="stats" *ngIf="!semCreativeCard.avg_position">--</span>
							<span class="stats-label">Avg. Position</span>
						</li>
					</ul>
				</div>
				<div class="sem-creative-card sem-creative-card-scroll">
					<div class="sem-creative-heading">{{ semCreativeCard.ad_headline }}</div>
					<div class="sem-creative-card-link-container">
						<span class="sem-creative-card-text">AD</span>
						<cite class="sem-creative-card-link">{{ semCreativeCard.url }}</cite>
					</div>
					<span class="sem-creative-card-roboto"> {{ semCreativeCard.callExtension }}</span>
					<div *ngIf="isTypeString(semCreativeCard?.description); else elseBlock" class="sem-creative-card-roboto">
						{{ semCreativeCard?.description }}
					</div>
					<ng-template #elseBlock>
						<div class="sem-creative-card-roboto">
							<p *ngFor="let desc of semCreativeCard?.description">
								{{ desc }}
							</p>
						</div>
					</ng-template>
					<div>
						<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
							<div>
								<p>
									<span *ngFor="let callout of semCreativeCard?.calloutsExtn; let i = index"
										>{{ callout
										}}<span [ngClass]="{ last_callout_class: i == semCreativeCard?.calloutsExtn.length - 1 }">
											&middot;
										</span></span
									>
								</p>
							</div>
						</div>
						<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
							<div *ngFor="let snippet of semCreativeCard?.structuredSnippetExtn">
								<p>{{ snippet?.type }}: {{ snippet?.value }}</p>
							</div>
						</div>
						<div class="sem-creative-card-siteLinks-container">
							<div *ngFor="let siteLink of semCreativeCard.siteLinks" class="sem-creative-card-sitelinks">
								<h4>
									<a href="{{ siteLink.link }}" target="_blank">{{ siteLink.heading }}</a>
								</h4>
								<span class="sem-creative-card-roboto">{{ siteLink.description }}</span>
							</div>
						</div>
						<div class="sem-creative-card-location" *ngIf="semCreativeCard?.location">
							<span
								><i class="fa fa-map-marker" aria-hidden="true" style="color: #575757;"></i>
								{{ semCreativeCard.location }}</span
							>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary u-color-white-900 c-portlet_box_specs"
		*ngIf="!hasData"
	>
		<img src="/assets/images/no-creative-performance-data-sem.png" class="no-creative-data" width="100%" />
	</div>
</div>
